import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "vote-activity"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");

import { ref } from 'vue';
import { getVoteActivityList, delVoteActivity } from '@/request';
import { dateTimeFormat, getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import SaveVoteActivityModal from './components/SaveVoteActivityModal.vue';
export default {
  name: 'VoteActivity',

  setup(__props) {
    const form = ref({
      status: '',
      time: [],
      activityName: ''
    });
    const formRef = ref();
    const showSaveModal = ref(false);
    const statusMap = {
      1: '未开始',
      2: '进行中',
      3: '已结束'
    };
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '活动名称',
        field: 'activityName'
      }, {
        title: '活动时间',
        field: 'activityStartTime',

        formatter({
          row
        }) {
          return `${row.activityStartTime}至${row.activityEndTime}`;
        }

      }, {
        title: '活动发起团队',
        field: 'supplierList',

        formatter({
          cellValue
        }) {
          return cellValue.map(i => i.supplierName).join(',');
        }

      }, {
        title: '活动状态',
        field: 'activityStatus',

        formatter({
          cellValue
        }) {
          return statusMap[cellValue] || '未知';
        }

      }, {
        title: '操作',
        width: '160px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            if (!form.value.time) {
              form.value.time = [];
            }

            getVoteActivityList({
              page: page.currentPage,
              rows: page.pageSize,
              activityStatus: form.value.status,
              activityStartTime: form.value.time.length ? form.value.time[0] : '',
              activityEndTime: form.value.time.length ? form.value.time[1] : '',
              activityName: form.value.activityName
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.activityList
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        status: '',
        time: [],
        activityName: ''
      };
      formRef.value.resetFields();
    }

    const table = ref(null);
    const editRow = ref(null);

    function edit(row) {
      editRow.value = row || null;
      showSaveModal.value = true;
    }

    function saveSuccess() {
      table.value.commitProxy('query');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm('是否确认删除选中活动?', '删除').then(() => {
        delVoteActivity({}, {
          params: {
            activityIds: selectRows.map(i => i.activityId).join(','),
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "活动名称",
              prop: "linkMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.activityName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.activityName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "活动时间",
              prop: "time"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.time,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.time = $event),
                "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": _unref(dateTimeFormat)
              }, null, 8, ["modelValue", "default-time", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "活动状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.status = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusMap, (item, val) => {
                  return _createVNode(_component_el_option, {
                    key: val,
                    label: item,
                    value: val
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        operation: _withCtx(({
          row
        }) => [row.activityStatus === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          icon: "View",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]))]),
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[4] || (_cache[4] = $event => edit(null))
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        _: 1
      }, 16), _createVNode(SaveVoteActivityModal, {
        editData: editRow.value,
        modelValue: showSaveModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showSaveModal.value = $event),
        onSuccess: saveSuccess
      }, null, 8, ["editData", "modelValue"])]);
    };
  }

};